import * as DialogPrimitive from '@radix-ui/react-dialog';
import { ArrowLeft } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/lib/utils';
import { Button } from './button';
// import { useNavigate } from 'react-router-dom';
// import { Button } from './button';

const Dialog = DialogPrimitive.Root;

const DialogTrigger = DialogPrimitive.Trigger;

const DialogPortal = DialogPrimitive.Portal;

const DialogClose = DialogPrimitive.Close;

const DialogOverlay = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className={cn(
      'fixed inset-0 z-50 bg-black/70  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
      className,
    )}
    {...props}
  />
));
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;

const DialogContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & {
    onClose: () => void;
  }
>(({ className, children, onClose, ...props }, ref) => (
  <DialogPortal>
    <DialogOverlay onClick={onClose} />
    <DialogPrimitive.Content
      ref={ref}
      className={cn(
        'fixed left-[50%] top-[50%] z-50 grid w-full rounded-[10px] overflow-hidden max-w-[650px] translate-x-[-50%] translate-y-[-50%] gap-4  bg-background  shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg',
        className,
      )}
      {...props}
    >
      {children}
      <DialogPrimitive.Close
        onClick={onClose}
        className='close-button  absolute right-4 top-[23px]  text-white rounded-sm  ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-1 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground items-center'
      >
        <span className='sr-only'>Close</span>
      </DialogPrimitive.Close>
    </DialogPrimitive.Content>
  </DialogPortal>
));
DialogContent.displayName = DialogPrimitive.Content.displayName;

const DialogHeader = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex flex-col space-y-1.5 text-center sm:text-left', className)} {...props} />
);
DialogHeader.displayName = 'DialogHeader';

const DialogFooter = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn('flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2', className)}
    {...props}
  />
);
DialogFooter.displayName = 'DialogFooter';

const DialogTitle = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Title>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Title>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Title
    ref={ref}
    className={cn('text-lg font-semibold leading-none tracking-tight', className)}
    {...props}
  />
));
DialogTitle.displayName = DialogPrimitive.Title.displayName;

const DialogDescription = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Description>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Description>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Description
    ref={ref}
    className={cn('text-sm text-muted-foreground', className)}
    {...props}
  />
));
DialogDescription.displayName = DialogPrimitive.Description.displayName;

export {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
};

interface DialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  children: React.ReactNode;
  title?: string;
  cancelButtonText?: string;
  saveButtonCondition?: boolean;
  saveButtonText?: string;
  loading?: boolean;
  disabled?: boolean;
  classNames?: string;
}

export const DialogBox: React.FC<DialogProps> = ({
  children,
  title,
  // saveButtonCondition = true,
  // cancelButtonText = 'Cancel',
  saveButtonText = 'Save',
  open,
  onClose,
  onSubmit,
  // loading,
  // disabled,
  classNames,
}) => {
  // const id = title?.toLowerCase()?.replace(' ', '-');

  return (
    <Dialog open={open}>
      <DialogContent onClose={onClose} className={cn(classNames)}>
        {title && (
          <div
            onClick={onClose}
            className='head bg-background pt-6 pb-4 px-5 text-2xl font-bold text-white flex items-center justify-between gap-2'
          >
            <div className='flex items-center gap-2'>
              <ArrowLeft className='cursor-pointer hover:bg-[#333] rounded-full' />
              {title}
            </div>
            <Button id='dialog-save-btn' onClick={onSubmit} size={'sm'} className='w-min'>
              {saveButtonText}
            </Button>
          </div>
        )}
        <div className='flex flex-col justify-between bg-[#141424]'>
          <div className='px-7 py-8 overflow-y-auto max-h-[600px]'>{children}</div>
          {/* <div className='py-[22.5px] px-4 flex items-center gap-2 border-[1px] justify-end'>
            <Button id={`${id}-cancel`} variant='outline' onClick={onClose}>
              {cancelButtonText}
            </Button>
            {saveButtonCondition && (
              <Button id={`${id}-save`} onClick={onSubmit} loading={loading} disabled={disabled}>
                {saveButtonText}
              </Button>
            )}
          </div> */}
        </div>
      </DialogContent>
    </Dialog>
  );
};
